import { render, staticRenderFns } from "./tauxCat.vue?vue&type=template&id=c590cc94&"
import script from "./tauxCat.vue?vue&type=script&lang=ts&"
export * from "./tauxCat.vue?vue&type=script&lang=ts&"
import style0 from "./tauxCat.vue?vue&type=style&index=0&id=c590cc94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports